import { getImg } from '../../../utils'
import { isUSVenture } from '../../../config'

export function getDateFormat () {
  return isUSVenture ? 'MM/DD/YYYY' : 'Do MMMM YYYY'
}

const componentTemplate = (post, posts) => {
  const postDateFormat = getDateFormat()
  const imageUrl = getImg(post.imageSlug, 25, 972)

  const authorName = post?.authorName ?? post?.author?.name
  return [
    {
      type: 'UnicornNavigationMenu'
    },
    {
      type: 'PostPage',
      props: {
        postDetails: {
          postHeader: post.title,
          postStandfirst: post.introduction,
          imageUrl,
          imageVariants: post?.imageVariants ?? [],
          content: post,
          categoryId: post.categoryId,
          subCategoryId: post.subCategoryId,
          postMeta: {
            authorId: post?.author?.id || '',
            authorName: authorName || '',
            authorImage: post?.author?.image || '',
            postDateTime: post.added,
            postDateFormat
          },
          tags: post.tags
        },
        listOfOtherPosts: posts,
        isBlog: true,
        defaultAuthorImage: '/uk/jackpotjoy/AuthorFallback.png'
      }
    }
  ]
}

export default componentTemplate
